// custom product swiper


$('.custom-product-swiper .purchase-btn .buy_now').on("click",function () {
    let id=$(this).data("id")
     $(`.buy_modal_popup[data-id="${id}"]`).fadeIn()
});
$(".custom-product-swiper .buy_modal_popup .close").on("click",function(){
   $(this).parents(".buy_modal_popup").fadeOut()
})


let shopify_features_script = document.querySelector("script[id='shopify-features']");
let shopify_features_json = JSON.parse(shopify_features_script.innerHTML);
var checkout_headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  authorization: 'Basic ' + btoa(shopify_features_json.accessToken),
};
$(".ajax-form[data-product-form]").each(function(){
  let sectionId=$(this).data("id");
  ajaxCart.init({
    formSelector: '#AddToCartForm--' + sectionId,
    cartContainer: '#CartContainer',
    addToCartSelector: '.AddToCart--' + sectionId,
    enableQtySelectors: true,
    moneyFormat: theme.strings.moneyFormat
  });
})

$('.buy_now--btn, .custom_buy_now--btn').on("click", function() {
  let layout = $(this).data("layout");
  
  // 安全获取数量
  let qty;
  if (layout == 'product') {
    const $quantityInput = $(this).parents(".data-product-form").find("#Quantity");
    qty = $quantityInput.length ? +$quantityInput.prop("value") || 1 : 1;
  } else {
    qty = 1;
  }
  
  // 获取变体ID
  let variant_id = layout == 'product' 
    ? +$(".product-single__variants option:selected").prop("value") 
    : $(this).data("id");
  
  const cartRoute = window.routes?.cart_url ?? '/cart';
  const paramString = `${variant_id}:${qty}`;
  const checkoutUrl = `${cartRoute}/${paramString}`;
  window.location.href = checkoutUrl;
});

$(".custom-product-swiper .purchase-btn .add_to_cart").on("click",function(){
  $(this).parent().find(".add-container").find("button.btn--add-to-cart").trigger("click")
  return false;
})

// end
// back to top
$(".fixed-page-btn").click(function () {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});
// end
